module.exports = __webpack_public_path__ + "media/fyt_m12.1adb3dd5.mp4";